import React, { Component } from 'react';
import './products.css';

export class Products extends Component {
    static displayName = Products.name;

    render() {
        return (
            <div className='products-body'>
                <div className='products-heading'>
                    <p><h1>OUR CORE PRODUCTS</h1></p>
                </div>
                <div className='regulatory-notice'>
                    <p><strong>NOTICE:</strong> In compliance with recently enacted Tennessee legislation (<a href="https://wapp.capitol.tn.gov/apps/billinfo/default.aspx?BillNumber=HB1376" className={"regulatory-notice-link"} target="_blank" rel="noopener noreferrer">HB 1376</a>), effective July 1, 2026, Magical Vapors will be temporarily suspending the sale of hemp-derived THC products at all locations while we conduct a thorough review to determine which products meet the updated regulatory standards. We deeply appreciate your patience and continued support as we navigate this transition. Please check back for updates — our commitment to providing quality, compliant products remains unchanged. If you have concerns about this legislation, we encourage you to <a href="https://wapp.capitol.tn.gov/apps/fml/lookup" className={"regulatory-notice-link"}  target="_blank" rel="noopener noreferrer">contact your local state representative</a>.</p>
                </div>
                <div className='products-list'>
                    <div className='products-list-top'>
                        <div className='products'>
                            <div className='product-section-heading'>
                                <span>NICOTINE</span>
                            </div>
                            <div className={'product-list'}>
                                <ul>
                                    <li>Disposables</li>
                                    <li>E-Liquid</li>
                                    <li>Nicotine Salts</li>
                                </ul>
                            </div>
                        </div>
                        <div className='products'>
                            <div className='product-section-heading'>
                                <span>HARDWARE</span>
                            </div>
                            <div className={'product-list'}>
                                <ul>
                                    <li>Pod Systems</li>
                                    <li>Mods</li>
                                    <li>Tanks (Sub-Ohm)</li>
                                </ul>
                            </div>
                        </div>
                        <div className='products'>
                            <div className='product-section-heading'>
                                <span>LIGHTERS</span>
                            </div>
                            <div className={'product-list'}>
                                <ul>
                                    <li>Lighters</li>
                                    <li>Torches</li>
                                    <li>Butane</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className={'products-section-middle'}>
                        <div className={'products-section'}>
                            <div className={'product-section-heading'}>
                                <span>ACCESSORIES</span>
                            </div>
                            <div className={'products'}>
                                <ul>
                                    <li>Glass Pipes</li>
                                    <li>Water Pipes</li>
                                    <li>Bubblers</li>
                                    <li>Dab Rigs</li>
                                    <li>Screens</li>
                                    <li>Hand-blown Glass</li>
                                </ul>
                                <ul>
                                    <li>Smell Proof Containers</li>
                                    <li>Grinders</li>
                                    <li>Glass Cleaner</li>
                                    <li>Isopropyl Alcohol</li>
                                    <li>Detox Products</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className='products-list-bottom'>
                        <div className='products'>
                            <div className='product-section-heading'>
                                <span>ORDOR ELIMINATORS</span>
                            </div>
                            <div className={'product-list'}>
                                <ul>
                                    <li>Sprays</li>
                                    <li>Incense</li>
                                </ul>
                            </div>
                        </div>
                        <div className='products'>
                            <div className='product-section-heading'>
                                <span>ALTERNATIVE</span>
                            </div>
                            <div className={'product-list'}>
                                <ul>
                                    <li>Kava</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
